import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { useTranslations } from '@lang';
import { CloseIcon } from '@root/styles/icons';

const StyledDeleteIcon = styled(CloseIcon)`
  display: none;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};

  ${media.md`
    display: block;
  `}
`;

const RemoveText = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.customColors.secondary};
  ${media.md`
    display: none;
  `}
`;

const StyledButton = styled.button`
  border: 0;
  background: none;
  align-self: center;
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  cursor: pointer;
  display: flex;
  padding: 10px 0 0 0;
`;

const RemoveGuestButton = ({ isVisible = true, onClick }) => {
  const { t } = useTranslations();
  return (
    <StyledButton isVisible={isVisible} type="button" onClick={onClick}>
      <RemoveText>{t('basket.remove')}</RemoveText>
      <StyledDeleteIcon width="24" height="24" />
    </StyledButton>
  );
};
RemoveGuestButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
};

export default RemoveGuestButton;
